import { Capacitor } from '@capacitor/core';

import { useAuthStore } from '@/shared/auth/authStore';
import { USER_ROLE } from '@/shared/constants';

/**
 * 앱 셸(상단바+하단탭바)을 보여줄지 결정한다.
 * - 네이티브 앱: 항상 앱 셸 (student/parent 라우트만 번들에 있어 role 체크가 필요 없다)
 * - 웹: student/parent 역할은 PC에서도 화면 폭과 무관하게 앱 셸(PC에서는 중앙 정렬된 폰 폭 컬럼).
 *   admin/staff/instructor는 항상 데스크톱 셸을 쓴다.
 */
export function useIsMobileShell() {
  const userRole = useAuthStore((state) => state.userInfo.userRole);
  const isStudentOrParent = userRole === USER_ROLE.STUDENT || userRole === USER_ROLE.PARENT;

  return Capacitor.isNativePlatform() || isStudentOrParent;
}
